/**
 * Payment return state belongs to the initiating tab. Mirror writes to local
 * storage for legacy/native returns, but never read another tab's newer values
 * after this tab has established its own context (including an invalidation).
 */
const prefix = 'maikuru:payment:';
const marker = `${prefix}initialized`;
export const paymentContextKeys = [
  'token',
  'm_customer_id',
  'loginType',
  'loginTel',
  'm_car_id',
  't_order_id',
  'globalTheme',
  'karteUrlTheme',
  'isLoggedInToMaikuru',
  'gmo_redirect_info',
  'gmo_expected_return',
  'gmo_expected_cancel',
  'gmo_redirect_fromPage',
  'fromPage',
  'source_page',
  'destination_page',
  'destination_step',
  'prevPage',
  'reserve_amount',
  'charge_amount',
  'm_prepaid_id',
  'postGmoNav',
  'paymentRedirectPage',
  'prepaid_registration_info',
  'currentCarId',
  'step',
  'car_wash_step_1',
  'car_wash_step_2',
  'car_wash_step_3',
  'coating_step_1',
  'coating_step_2',
  'coating_step_3',
  'coating_create_data',
  'coating_total_fee',
  'coating_total_working_minutes',
  'coating_t_payment_managements_id',
  'gmopg_site_id',
  'gmopg_shop_id',
  'OrderID',
  'DateTime',
  'MemberID',
] as const;

export const createPaymentStorage = (local: Storage, tab: Storage) => {
  const initialize = () => {
    if (tab.getItem(marker)) return;
    for (const key of paymentContextKeys) {
      const value = local.getItem(key);
      if (value !== null) tab.setItem(prefix + key, value);
    }
    tab.setItem(marker, 'true');
  };
  return {
    getItem(key: string): string | null {
      return tab.getItem(marker)
        ? tab.getItem(prefix + key)
        : local.getItem(key);
    },
    setItem(key: string, value: string): void {
      initialize();
      tab.setItem(prefix + key, value);
      local.setItem(key, value);
    },
    removeItem(key: string): void {
      initialize();
      tab.removeItem(prefix + key);
      local.removeItem(key);
    },
    invalidate(): void {
      initialize();
      for (const key of paymentContextKeys) {
        // loginTel remains available for normal phone-login/number-change flows.
        tab.removeItem(prefix + key);
        if (key !== 'loginType' && key !== 'loginTel') local.removeItem(key);
      }
    },
  };
};

export const paymentStorage = {
  getItem: (key: string) =>
    createPaymentStorage(window.localStorage, window.sessionStorage).getItem(
      key,
    ),
  setItem: (key: string, value: string) =>
    createPaymentStorage(window.localStorage, window.sessionStorage).setItem(
      key,
      value,
    ),
  removeItem: (key: string) =>
    createPaymentStorage(window.localStorage, window.sessionStorage).removeItem(
      key,
    ),
};

export const invalidatePaymentContext = () => {
  if (typeof window === 'undefined' || !window.sessionStorage) return;
  createPaymentStorage(window.localStorage, window.sessionStorage).invalidate();
};
